export const COUPON_STATUS = {
  /** 待激活 */
  toActive: 1,
  /** 生效 */
  useable: 2,
  /** 作废 */
  invalid: 3
}

/**
 * 券类型
 */
export const COUPON_TYPE = {
  /** 1-满减券 */
  FULL_REDUCE: 1,
  /** 2-现金券 */
  CASH: 2,
  /** 3 折扣券  */
  DISCOUNT: 3
}
export const COUPON_TYPES = new Map([
  [COUPON_TYPE.FULL_REDUCE, '满减券'],
  [COUPON_TYPE.CASH, '现金券'],
  [COUPON_TYPE.DISCOUNT, '折扣券']
])
/** 商家券、平台券 */
export const COUPON_CATEGORY_TYPE = {
  BUSINESS: 1,
  PLATFORM: 2
}
export const COUPON_CATEGORY_TYPES = new Map([
  [COUPON_CATEGORY_TYPE.BUSINESS, '商家券'],
  [COUPON_CATEGORY_TYPE.PLATFORM, '平台券']
])
export default class B_COUPON {
  /** 券可用状态 */
  static isUseable(couponInfo) {
    const nowTime = new Date().getTime()
    return (
      +couponInfo.status === COUPON_STATUS.useable &&
      +couponInfo.isShow === 1 &&
      couponInfo.getStartTime <= nowTime &&
      couponInfo.getEndTime >= nowTime
    )
  }
  /** 获取券内容 */
  static getCouponText(couponInfo) {
    const { couponType, couponAmount, useAmountLimit, couponName } = couponInfo
    if (this.isFullReduce(couponType)) {
      return `满${useAmountLimit / 100}减${couponAmount / 100}`
    }
    return couponName
  }
  static getCouponText1(couponInfo) {
    const { couponType, couponAmount, useAmountLimit, couponName } = couponInfo
    if (this.isFullReduce(couponType)) {
      return `满${useAmountLimit / 100}减${couponAmount / 100}`
    }
    return `${couponAmount / 100}元现金券`
  }
  /** 是否为满减券 */
  static isFullReduce(couponType) {
    return +couponType === COUPON_TYPE.FULL_REDUCE
  }
}
